/* Publish by EComposer at 2025-07-31 14:04:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zzjj2p8ze2q"]=  window.__ectimmers["ecom-zzjj2p8ze2q"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zzjj2p8ze2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzjj2p8ze2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ji5rco3vres').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ji5rco3vres', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4x4kykt5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4x4kykt5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mal3c1gilbn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mal3c1gilbn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-akzlo2i4szl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-akzlo2i4szl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htkdofgbrzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htkdofgbrzi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cq8tccg2uuq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cq8tccg2uuq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aaaqsf57z7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aaaqsf57z7j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d68ebzavaxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d68ebzavaxn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rl3xs8k1tss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl3xs8k1tss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thjo9xfziwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thjo9xfziwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewg7187y3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewg7187y3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sf4o2j63fkt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sf4o2j63fkt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9d6l6a58o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9d6l6a58o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itvc9laa7cf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itvc9laa7cf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hyyq5hzra5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hyyq5hzra5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7142b5vn7p6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7142b5vn7p6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vejsdfhuzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vejsdfhuzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3h9npusi0w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3h9npusi0w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fcrwsmhpoqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fcrwsmhpoqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojg6vwd0ee8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojg6vwd0ee8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fk7jxxynf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fk7jxxynf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jvu11y0a9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jvu11y0a9k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emapn3mqwrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emapn3mqwrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wu0qkzllk4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wu0qkzllk4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jo89k7r327n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jo89k7r327n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xzvboifecl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xzvboifecl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv0rhy8c8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv0rhy8c8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppegb8y32qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppegb8y32qb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku6t4drfz9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku6t4drfz9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ru64d2wv9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ru64d2wv9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svrj5jrl3yc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svrj5jrl3yc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufhrq4sgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufhrq4sgf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-py7pqmx9h1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-py7pqmx9h1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-384k8rjthqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-384k8rjthqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6rj69jejym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6rj69jejym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su2x9e9014i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su2x9e9014i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dczjxircp8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dczjxircp8u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ep72hrl5p9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ep72hrl5p9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kalzkqj1jgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kalzkqj1jgf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hh0tdnl089').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hh0tdnl089', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0j44fblaas1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0j44fblaas1v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfu0wrsdieg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfu0wrsdieg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fbjs4gv5ic7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fbjs4gv5ic7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xo8j2jh9r8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xo8j2jh9r8s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2q06n3520ua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2q06n3520ua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mlemf3e5u7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mlemf3e5u7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgoqdt60vih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgoqdt60vih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1qz7p1odsfm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1qz7p1odsfm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2vz7oymg4up').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vz7oymg4up', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5ykp1t9eja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5ykp1t9eja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-989aucm2ht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-989aucm2ht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkov9bgh32').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkov9bgh32', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csyh7ygqxog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csyh7ygqxog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xs2oh1iied').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xs2oh1iied', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-se48qvvyqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-se48qvvyqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loqwfie5w18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loqwfie5w18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ayto85a728k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ayto85a728k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ytylkv2tnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ytylkv2tnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fir4g2b162o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fir4g2b162o', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e72dmlgygih"]=  window.__ectimmers["ecom-e72dmlgygih"] || {};
var g,b,u,x,$,v;let e=this.$el;if(!e)return;let i=this.isLive;const t=(g=this.settings.disable_auto_close)!=null?g:!1,n=(b=this.settings.disable_auto_close__tablet)!=null?b:!1,s=(u=this.settings.disable_auto_close__mobile)!=null?u:!1,o=(x=this.settings.scroll_on_mobile)!=null?x:!1,a=($=this.settings.disable_effect)!=null?$:!1,r=(v=this.settings.close_all)!=null?v:!1,c=e.querySelectorAll(".ecom-accordion__item > .ecom-accordion__title");function m(w){const f=w.getBoundingClientRect();return f.top>=0&&f.left>=0&&f.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&f.right<=(window.innerWidth||document.documentElement.clientWidth)}function l(w){let f=window.screen.width;window.EComposer.TEMPLATE_ID||(f=window.innerWidth),w.forEach((k,L)=>{let T=k.parentNode.querySelector(".ecom-accordion__body");!a&&T&&T.classList.add("ecom-effect-accodion"),L==0&&(T.style.height=T.clientHeight+"px"),k.onclick=function(M){M.preventDefault();let z=this.parentNode,S=z.parentNode;const q=S.querySelectorAll(".ecom-accordion__item"),P=S.querySelectorAll(".ecom-accordion__title");if(z.classList&&z.classList.remove("ecom-item-group-init"),this.classList&&this.classList.contains("ecom-item-active"))s&&f<768||n&&f>767&&f<1025||t&&f>1024?(this.classList.remove("ecom-item-active"),z.querySelector(".ecom-accordion__body").style.height="0px",z.querySelector(".ecom-accordion__title").classList.remove("ecom-item-active"),z.classList.remove("ecom-item-active")):(q.forEach(D=>h(D)),P.forEach(D=>D.classList.remove("ecom-item-active")));else{s&&f<768||n&&f>767&&f<1025||t&&f>1024||(q.forEach(N=>h(N)),P.forEach(N=>N.classList.remove("ecom-item-active"))),k.classList.add("ecom-item-active"),z.classList.add("ecom-item-active");let D=k.parentNode.querySelector(".ecom-accordion__body");k.parentNode.closest(".ecom-accordion__body")&&(k.parentNode.closest(".ecom-accordion__body").style.height="auto"),D.style.height="auto";let W="auto";a||(W=i?D.clientHeight+"px":"auto",D.classList.add("ecom-effect-accodion")),D.style.height="0px",setTimeout(()=>{D.style.height=W},10)}window.dispatchEvent(new window.Event("renderScroll")),setTimeout(()=>{window.dispatchEvent(new window.Event("renderScroll")),o?m(this)||R():!m(this)&&f>1024&&R()},50);function A(D){let W=0;if(D.offsetParent){do W+=D.offsetTop;while(D=D.offsetParent);return[W]}}function R(D){window.scrollTo(0,A(e)-100)}}})}function h(w){w.classList.remove("ecom-item-active"),w.querySelector(".ecom-accordion__body").style.height="0"}l(c),r||setTimeout(()=>{e.querySelector(".ecom-item-group-init")&&e.querySelector(".ecom-item-group-init").classList.remove("ecom-item-group-init")},500);function y(){let w=window.location.hash;if(w){let f=e.querySelector(`[data-target="${w}"]`);if(f){f.click();let k=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});f.dispatchEvent(k);let M=f.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,M)}}}setTimeout(function(){y()},300),window.addEventListener("resize",function(){l(c)}),window.addEventListener("hashchange",y,!1)

                    });
                    
                        document.querySelectorAll('.ecom-e72dmlgygih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e72dmlgygih', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xie1s511jvb"]=  window.__ectimmers["ecom-xie1s511jvb"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-xie1s511jvb"]["y46il7t1l"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xie1s511jvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xie1s511jvb', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}